import type { SideSwapDetail } from '../api/sideSwaps'

// The side swap answer's wording, as pure functions.

export interface SwapSides {
  mine: string
  theirs: string
  /** The side my team starts on now, and would start on after the swap. */
  myNow: string
  myAfter: string
}

export function swapSides(d: Pick<SideSwapDetail, 'team_id' | 'teams' | 'side_names' | 'starting_sides' | 'game_number'>): SwapSides | null {
  if (d.side_names.length !== 2) return null
  const mine = d.teams.find((t) => t.team_id === d.team_id)
  const theirs = d.teams.find((t) => t.team_id !== d.team_id)
  const game = d.starting_sides.find((s) => s.game_number === d.game_number)
  if (!mine || !theirs || !game) return null
  const startsFirst = game.first_side_team_id === mine.team_id
  return {
    mine: mine.name,
    theirs: theirs.name,
    myNow: startsFirst ? d.side_names[0] : d.side_names[1],
    myAfter: startsFirst ? d.side_names[1] : d.side_names[0],
  }
}

/** "Sunset. You're scheduled to start on Attack. If you agree, …" */
export function swapExplanation(map: string, sides: SwapSides, gameNumber: number): string {
  const where = map ? `${map}. ` : `Game ${gameNumber}. `
  return `${where}You're scheduled to start on ${sides.myNow}. If you agree, ${sides.theirs} starts on ${sides.myNow} and ${sides.mine} starts on ${sides.myAfter}.`
}

export function swapOutcome(status: SideSwapDetail['status']): string {
  switch (status) {
    case 'accepted': return 'Swapped. Both teams and the league have the new sides.'
    case 'declined': return 'You kept the sides as scheduled.'
    case 'cancelled': return 'This request was withdrawn.'
    default: return ''
  }
}
